// Presence helpers shared by Messages list + ChatThread

export function presenceLabel(lastSeenISO, t) {
  if (!lastSeenISO) return "";
  const last = new Date(lastSeenISO).getTime();
  const diff = Math.max(0, Date.now() - last);
  if (diff < 60_000) return t("online");
  return `${t("lastSeen")} ${shortRelative(diff, t)}`;
}

export function isOnline(lastSeenISO) {
  if (!lastSeenISO) return false;
  return Date.now() - new Date(lastSeenISO).getTime() < 60_000;
}

function shortRelative(diffMs, t) {
  const m = Math.floor(diffMs / 60_000);
  if (m < 60) return `${m}${t("minutesAgo")}`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}${t("hoursAgo")}`;
  const d = Math.floor(h / 24);
  return `${d}${t("daysAgo")}`;
}
